import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  Stack,
} from "@mui/material";
import TimerIcon from "../../../assets/icons/timer.gif";
import Cookies from "js-cookie";
import "./logout-timer-clock.scss";

const formatTime = (totalSeconds: number) => {
  const m = Math.floor(totalSeconds / 60);
  const s = totalSeconds % 60;
  return `${m.toString().padStart(2, "0")}:${s.toString().padStart(2, "0")}`;
};

export default function LogOutTimerClock(props: any) {
  const total = 5; // 1 minute
  const [timeLeft, setTimeLeft] = useState(total);
  const [open, setOpen] = useState(props?.forceLogoutUpdate);

  useEffect(() => {
    if (!open) return;
    if (timeLeft <= 0) return;

    const timer = setInterval(() => {
      setTimeLeft((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [timeLeft, open]);

  // Auto close when time ends
  useEffect(() => {
    if (timeLeft === 0) {
      setOpen(false);
      globalThis.location.href = "/login";
    }
    localStorage.clear();
    sessionStorage.clear();
    Cookies.remove("userDetails");
  }, [timeLeft]);

  return (
    <Dialog
      open={true}
      onClose={() => {}}
      maxWidth={false}
      slotProps={{
        paper: {
          sx: {
            borderRadius: "10px",
            maxWidth: "500px",
          },
        },
      }}
    >
      <DialogTitle
        sx={{ textAlign: "center", color: "#1B2F3F", fontWeight: 600 }}
      >
        Session Ending Soon
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2} alignItems="center" sx={{ py: 2 }}>
          <div className="logout-timer">
            <img alt="Timer icon" src={TimerIcon} />
          </div>

          <Typography
            variant="h4"
            sx={{ textAlign: "center", fontSize: "18px", fontWeight: 600 }}
          >
            {formatTime(timeLeft)}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: "center" }}
          >
            For security reasons, your session will end shortly.
            <br />
            Please re-login to access LED.
          </Typography>

          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              sx={{
                borderRadius: "30px",
                textTransform: "none",
                width: "187px",
                height: "42px",
                backgroundColor: "#F15B59",
                "&:hover": {
                  backgroundColor: "#d14b49",
                },
              }}
              onClick={() => {
                setOpen(false);
                globalThis.location.href = "/login";
              }}
            >
              Logout Now
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
